<template>
	<div>
		<div class="py-4" > 
			<div class="d-flex h-100 align-items-center" v-if="do_later">
				<do-later ></do-later>
			</div>
			<div class="d-flex h-100 align-items-center" v-else>
				<!------step-one---->	
				<app-step-one v-if="parseInt(get_user.step) == 0"></app-step-one>
				<!------step-two---->
				<app-step-two v-else-if="parseInt(get_user.step) == 1"></app-step-two>
				<!------step-threeA---->
				<app-step-three-a v-else-if="parseInt(get_user.step) == 2"></app-step-three-a>
				<!------step-three-->
				<app-step-three v-else-if="parseInt(get_user.step) == 3"></app-step-three>
				<!------step-four---->
				<app-step-four v-else-if="parseInt(get_user.step) == 4"></app-step-four>
				<!------step-five---->
				<app-step-five v-else-if="parseInt(get_user.step) == 5 || parseInt(get_user.profile.ipv_status) == 0"></app-step-five>
				<!-------create-live-account----->
				<create-live-account v-else-if="parseInt(get_user.step) == 6"></create-live-account>
			</div>
		</div>
	</div>
</template>
<script>
	import step1 from '../registerSteps/step1'
	import step2 from '../registerSteps/step2'
	import step3 from '../registerSteps/step3'
	import step3a from '../registerSteps/step3.0'
	import step4 from '../registerSteps/step4'
	import step5 from '../registerSteps/step5'
	import doLater from '../registerSteps/do_later'
	import createLiveAccount from '../tradingAccounts/create_account_live.vue'
	import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'steps',
		mixins: [fxViewMixins],
        data() {
            return {
				do_later : false
            }
        },
		components: {
			doLater: doLater, 
			appStepOne: step1, 
			appStepTwo: step2,
			appStepThreeA: step3a,
			appStepThree: step3, 
			appStepFour: step4, 
			appStepFive: step5,
			createLiveAccount : createLiveAccount
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/register_steps.vue